import React, { useState } from "react"
import PropTypes from "prop-types"
import HelloCard from "./hello_card"

const SLAPrompt = ({ upgradeUrl, eligibleForTrial, slug, imgSet }) => {
  const [hidden, setHidden] = useState(false)

  const object_id = slug

  if (hidden) return null

  let ctaTitleCopy = eligibleForTrial ? "Try now, pay later" : "Upgrade"
  let mainBodyCopy = "Your new Applet will run faster with Pro!"
  let noCreditCardCopy = eligibleForTrial
    ? "Get a week free, no credit card required."
    : null

  return (
    <HelloCard
      ctaTitle={ctaTitleCopy}
      clickAcceptUrl={upgradeUrl}
      clickAcceptTracking={{
        object_id,
        object_type: "get_pro",
        location_type: "sla_prompt",
      }}
      clickDeclineTracking={{
        object_id,
        object_type: "maybe_later",
        location_type: "sla_prompt",
      }}
      onClickDecline={e => {
        e.preventDefault()
        setHidden(true)
      }}
      declineCopy="Maybe later"
      logoHtml={imgSet}
      mainTitle="Better with IFTTT Pro"
      mainBody={mainBodyCopy}
      noCreditCardCopy={noCreditCardCopy}
    />
  )
}

SLAPrompt.propTypes = {
  eligibleForTrial: PropTypes.bool,
  upgradeUrl: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  imgSet: PropTypes.string.isRequired,
}

export default SLAPrompt
